import React, { useEffect, useState } from 'react';
import {
    Col,
    Row,
    VertCarousel,
    VertContainer,
    VertImage,
} from '@vertem-core/vertice-ds';
import SkeletonButton from 'antd/es/skeleton/Button';
import '@/Assets/styles/default/components/BannerSupplier/BannerSupplierStyle.less';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const CarouselConfig = {
    dots: false,
    arrows: false,
    itemsPerPage: 1,
    variableWidth: false,
};

const CustomBannerSupplier = () => {
    const Navigate = useNavigate();
    const isMobile = useMediaQuery({ maxWidth: '768px' });
    const [loading, setLoading] = useState(false);
    const banner = { icon: 'https://vertice-ds.s3.amazonaws.com/Assets/Images/acessaagro/Banner+Cat%C3%A1logo+Desk+-+1286x206.png', path: '/campanhas' };


    return (
        <VertContainer>
            <section
                className={`padding-x-regular ${isMobile ? 'padding-y-small' : 'padding-y-big margin-bottom-big'
                    }`}
            >
                {loading ? (
                    <Row>
                        <SkeletonButton
                            active
                            shape="round"
                            rootClassName="col padding-x-extra-small BannerSupplierItem-loading"
                        />
                    </Row>
                ) : (
                    <VertCarousel {...CarouselConfig}>
                        <div>
                            <Row>
                                <VertImage
                                    src={'https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/banner-aniversario.png'}
                                />
                            </Row>
                        </div>
                    </VertCarousel>
                )}
            </section>
        </VertContainer>
    );
};

export default CustomBannerSupplier;
